import { createAction } from 'redux-actions';

export const fetchModuleDataSuccess = createAction(
  'MODULE.FETCH.SUCCESS',
  (payload: Record<string, any>) => payload
);

export interface UpdateModulePayload {
  id: number;
  moduleMeta?: any;
  moduleData?: any;
}
export const updateModule = createAction(
  'MODULE.UPDATE',
  (payload: UpdateModulePayload) => payload
);

export type ModuleConfigPayload = {
  moduleId: number;
};
export const fetchModuleConfig = createAction(
  'MODULE.CONFIG.FETCH',
  (payload: ModuleConfigPayload) => payload
);

export const fetchModuleConfigSuccess = createAction(
  'MODULE.CONFIG.FETCH.SUCCESS',
  (payload: { id: number; config: any }) => payload
);

export const saveModuleConfig = createAction(
  'MODULE.CONFIG.SAVE',
  (payload: Record<string, any>) => payload
);

export const purgeAllModules = createAction('MODULE.PURGE.ALL', () => ({}));
